module.exports = __webpack_public_path__ + "media/images/sales/set/eyecatch-set-01-64e11ea6e08cdbecdff9ebcdf58da10f.svg";